import FetchService from "@core-ui/ApiServices/FetchService";
import Method from "@core-ui/ApiServices/Types/Method";
import MimeTypes from "@core-ui/ApiServices/Types/MimeTypes";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import useObjectUrl from "@core-ui/hooks/useObjectUrl";
import useChatStore from "@ext/agent/components/store/ChatStore";
import type { ChatAttachment } from "@ext/agent/core/attachmentStore";
import { useEffect, useState } from "react";

export const useStoredAttachmentSrc = (attachment: ChatAttachment) => {
	const sessionId = useChatStore((s) => s.activeSessionId);
	const apiUrlCreator = ApiUrlCreatorService.value;
	const { url: src, setBlob } = useObjectUrl();
	const [failed, setFailed] = useState(false);
	const { storagePath, mime } = attachment;

	useEffect(() => {
		if (!sessionId) return undefined;
		let cancelled = false;
		const load = async () => {
			const url = apiUrlCreator.getAgentSessionAttachmentUrl(sessionId, storagePath);
			const res = await FetchService.fetch(url, undefined, MimeTypes.text, Method.GET, false);
			if (cancelled) return;
			if (!res.ok) return setFailed(true);
			const bytes = await res.arrayBuffer();
			if (!cancelled) setBlob(new Blob([bytes], { type: mime }));
		};
		load().catch(() => {
			if (!cancelled) setFailed(true);
		});
		return () => {
			cancelled = true;
		};
	}, [sessionId, storagePath, mime, setBlob]);

	return { src, failed };
};
